module.exports = {
    API_URL : "https://movie-api-vudt.onrender.com"
}